export const CONTENT_XR = "CONTENT.XR";
export const CONTENT_XR_QUIZ = "CONTENT.XR.QUIZ";
export const CONTENT_XR_SOPS = "CONTENT.XR.SOPS";
export const CONTENT_XR_PASSING = "CONTENT.XR.PASSING";
export const CONTENT_XR_ASSETS = "CONTENT.XR.ASSETS";
export const CONTENT_XR_TASKS = "CONTENT.XR.TASKS";
export const CONTENT_XR_CREATE = "CONTENT.XR.CREATE";

export const CONTENT_ENVIRONMENT = "CONTENT.ENVIRONMENT";
export const CONTENT_ENVIRONMENT_CREATE = "CONTENT.ENVIRONMENT.CREATE";

export const CONTENT_DYNAMIC_CONTENT = "CONTENT.DYNAMIC.CONTENT";

export const CONTENT_CATEGORY = "CONTENT.CATEGORY";
export const CONTENT_CATEGORY_CREATE = "CONTENT.CATEGORY.CREATE";

export const CONTENT_AR = "CONTENT.AR";
export const CONTENT_AR_CREATE = "CONTENT.AR.CREATE";

export const CONTENT_2D = "CONTENT.2D";

export const CONTENT_3D = "CONTENT.3D";
export const CONTENT_3D_CREATE = "CONTENT.3D.CREATE";